/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.playback.whep";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"streamer":/*#__PURE__*/ l.string(),"rendition":/*#__PURE__*/ l.string()});

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.payload("*/*");

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.payload("*/*");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Play a stream over WebRTC using WHEP. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized"]);

export { main };

export const $lxm = $nsid;
